const Base = 'Constructor' as const;

/**
 * Имена продуктовых событий конструктора (дерево → строки вида Constructor.*).
 * Значение и additional передаются в logEventString отдельно.
 */
export const constructorProductLoggingEvents = {
    LimitAchieved: {
        page: `${Base}.LimitAchieved.page`,
        section: `${Base}.LimitAchieved.section`,
        module: `${Base}.LimitAchieved.module`,
    },
    Template: {
        Apply: `${Base}.Template.Apply`,
    },
    Page: {
        Visibility: `${Base}.Page.Visibility`,
        Add: `${Base}.Page.Add`,
        Delete: `${Base}.Page.Delete`,
        Rename: `${Base}.Page.Rename`,
    },
    LeftBar: {
        SettingsTab: `${Base}.LeftBar.SettingsTab`,
    },
    RightBar: {
        Toggle: `${Base}.RightBar.Toggle`,
    },
    Section: {
        Add: `${Base}.Section.Add`,
        Delete: `${Base}.Section.Delete`,
        Copy: `${Base}.Section.Copy`,
        Paste: `${Base}.Section.Paste`,
        ReplaceFromClipboard: `${Base}.Section.ReplaceFromClipboard`,
        Visibility: `${Base}.Section.Visibility`,
    },
    SectionType: {
        MakeParent: `${Base}.SectionType.MakeParent`,
        Detach: `${Base}.SectionType.Detach`,
        Replace: `${Base}.SectionType.Replace`,
    },
    Version: {
        Change: `${Base}.Version.Change`,
    },
    LocalSave: {
        Restore: `${Base}.LocalSave.Restore`,
        Discard: `${Base}.LocalSave.Discard`,
        ClearedOnSave: `${Base}.LocalSave.ClearedOnSave`,
    },
} as const;
